import React from 'react';
import * as R from 'ramda';
import {FormLabel} from 'js/form_components';

const InputRange = props => (
    <div className="form-group">
        <FormLabel
            className={props.className}
            label={props.header}
            helpText={props.help}
            multiline
            inline
            place="right"
        />
        <div className="input-group">
            <input
                value={R.isNil(props.valueMin) ? '' : props.valueMin}
                onChange={e => props.onChangeMin(e.target.value)}
                className="input-sm form-control"
            />
            <span className="input-group-addon">to</span>
            <input
                value={R.isNil(props.valueMax) ? '' : props.valueMax}
                onChange={e => props.onChangeMax(e.target.value)}
                className="input-sm form-control"
            />
        </div>
    </div>
);

export default InputRange;



// WEBPACK FOOTER //
// ./publisher_leads/advanced_filters/input_range.js